import { Empty } from 'antd';
import React from 'react';

const DrawerPanelListTaskEmpty = () => {
    return <Empty description={'No data to display'} style={{ padding: 30 }} />;
};

export default DrawerPanelListTaskEmpty;
